<template>
    <div :class="['ThePageExternal',className]">
        <div class="ThePageExternal__header">
            <TheLogo/>
            <div class="ThePageExternal__title">
                {{translate(title)}}
            </div>
        </div>
        <div class="ThePageExternal__content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import TheLogo from './TheLogo.vue';

    export default {
        name: 'ThePageExternal',
        components: {
            TheLogo
        },
        props: {
            //Title of the page
            title: {
                type: String
            },
            //Additional css class name for styling
            className: {
                type: String
            }
        }
    };
</script>

<style>
    .ThePageExternal {
        display: flex;
        flex-direction: column;
        background-color: rgba(96, 125, 139, 0.2);
        margin: 30px;
        max-width: 100%;
        min-height: 100%;
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);
        border-radius: 2px;
    }

    @media (max-width: 360px) {
        div.ThePageExternal {
            margin: 0px;
            border-radius: 0px;
            max-height: none;
        }
    }

    .ThePageExternal__header {
        display: flex;
        flex-direction: row;
        padding: 10px;
        background: rgba(96, 125, 139, 0.2);
    }

    .ThePageExternal__title {
        padding-top: 9px;
        font-size: 12px;
        font-weight: 500;
        color: rgba(255,255,255,0.5);
        text-transform: uppercase;
        font-family: Roboto,sans-serif;
    }

    .ThePageExternal__content {
        padding: 30px 24px 0 24px;
        display: flex;
        flex-direction: column;
    }

</style>



// WEBPACK FOOTER //
// ThePageExternal.vue?11ff6c04